import { selectUserRolePermissions } from '@socialive/common';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const streamsTab = {
  id: 'streams',
  type: 'streams',
  label: 'RECORDINGS',
};

const clipsTab = {
  id: 'clips',
  type: 'clips',
  label: 'CLIPS',
};

const BroadcastDetailsNav = ({ activeTabId, handleOnclick }) => {
  const { canClipVideo } = useSelector(selectUserRolePermissions);

  const tabs = useMemo(() => [streamsTab, canClipVideo && clipsTab].filter(Boolean), [canClipVideo]);

  return (
    <div className="broadcast-details-nav-container">
      <ul className="broadcast-details-nav">
        {tabs.map((tab) => (
          <li key={tab.id} className={`broadcast-details-nav-item ${tab.id} ${tab.id === activeTabId ? 'active' : ''}`}>
            <button type="button" className={`${tab.type} btn text`} onClick={() => handleOnclick(tab.type)}>
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

BroadcastDetailsNav.propTypes = {
  activeTabId: PropTypes.string.isRequired,
  handleOnclick: PropTypes.func.isRequired,
};

export default BroadcastDetailsNav;
